import { AppointmentType } from "src/services/availability";

const afterHoursServiceTypeId = 246;

const nonStandardServiceTypeIds = [
    afterHoursServiceTypeId,
];

const telehealthServiceTypeIds = [
    // telehealth
    29
];

export const newPatientRegex = /\s*\W?\s?[Nn][Ee][Ww] [Pp][Aa][Tt][Ii][Ee][Nn][Tt]\W?\s*/;

export function isMedibankFluCampaign(appointmentType: AppointmentType) {
    return appointmentType.appointmentName === "Medibank Flu Vaccination"
}

export function filterToStandardAppointmentTypes(data: AppointmentType[]): AppointmentType[] {
 return data?.filter(apt => !nonStandardServiceTypeIds.includes(apt.serviceTypeId) && !isMedibankFluCampaign(apt))
}

export function filterToAfterHoursAppointmentTypes(data: AppointmentType[]): AppointmentType[] {
 return data?.filter(apt => apt.serviceTypeId === afterHoursServiceTypeId);
}

export function isFaceToFace(appointmentType: AppointmentType) {
    return appointmentType.isF2F || (!telehealthServiceTypeIds.includes(appointmentType.serviceTypeId) && !isAfterHours(appointmentType));
}

export function isAfterHours(appointmentType: AppointmentType) {
    return appointmentType.serviceTypeId === afterHoursServiceTypeId;
}